module.exports = __webpack_public_path__ + "img/PERKI E-OFFICE.0dee589d.svg";